function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Mask");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 C7.168,0 0,7.168 0,16 C0,24.832 7.168,32 16,32 C24.832,32 32,24.832 32,16 C32,7.168 24.832,0 16,0 Z M16,30.048 C8.288,30.048 2.016,23.712 2.016,16 C2.016,8.288 8.288,1.984 16,1.984 C23.712,1.984 30.016,8.288 30.016,16 C30.016,23.712 23.712,30.048 16,30.048 Z M21.664,10.336 C21.28,9.952 20.64,9.952 20.256,10.336 L16,14.592 L11.744,10.336 C11.36,9.952 10.72,9.952 10.336,10.336 C9.952,10.72 9.952,11.36 10.336,11.744 L14.592,16 L10.336,20.256 C9.952,20.64 9.952,21.28 10.336,21.664 C10.72,22.048 11.36,22.048 11.744,21.664 L16,17.408 L20.256,21.664 C20.64,22.048 21.28,22.048 21.664,21.664 C22.048,21.28 22.048,20.64 21.664,20.256 L17.408,16 L21.664,11.744 C22.048,11.36 22.048,10.72 21.664,10.336 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "close-line"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
})));

var SvgCloseButton = function SvgCloseButton(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    fill: "currentColor",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-button.e8592287.svg";
export { ForwardRef as ReactComponent };